var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5865 0.647461C8.57607 0.647461 6.13561 3.04273 6.13561 5.99745C6.13561 8.95217 8.57607 11.3474 11.5865 11.3474C14.597 11.3474 17.0375 8.95217 17.0375 5.99745C17.0375 3.04273 14.597 0.647461 11.5865 0.647461Z",
    fill: "#EB6424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77221 14.2008C2.76175 14.2008 0.321289 16.596 0.321289 19.5508V21.246C0.321289 22.3206 1.11477 23.2369 2.19535 23.4101C8.41497 24.4067 14.7581 24.4067 20.9777 23.4101C22.0583 23.2369 22.8518 22.3206 22.8518 21.246V19.5508C22.8518 16.596 20.4113 14.2008 17.4009 14.2008H16.9054C16.6372 14.2008 16.3707 14.2424 16.1158 14.3241L14.8577 14.7273C12.7321 15.4085 10.4409 15.4085 8.31538 14.7273L7.05728 14.3241C6.80236 14.2424 6.53587 14.2008 6.26769 14.2008H5.77221Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.637d8121b9ad6e6092d4ce740aa5df50.svg";
export { ForwardRef as ReactComponent };